import * as React from 'react';
import { useMemo } from 'react';
import cn from 'classnames';

import { Airport, OrderFlight } from '@websky/graphql';
import { useTheme } from '../../../../theme';

interface Props {
	flight: OrderFlight;
	bookingPreview?: boolean;
}

const OrderCities: React.FC<Props> = ({ flight, bookingPreview }) => {
	const { OrderPreview: css } = useTheme('OrderCard');

	const airports = useMemo<Airport[]>(() => {
		let isRoundTrip = false;

		if (flight.segmentGroups.length === 2) {
			const firstSegments = flight.segmentGroups[0].segments;
			const lastSegments = flight.segmentGroups[1].segments;

			const firstCity = firstSegments[0].departure.airport.city?.id;
			const lastCity = lastSegments[lastSegments.length - 1].departure.airport.city?.id;
			if (firstCity === lastCity) {
				isRoundTrip = true;
			}
		}

		// if there and back then only the starting city and the ending city of the first flight are displayed
		if (isRoundTrip) {
			const segments = flight.segmentGroups[0].segments;
			const first = segments[0];
			const last = segments[segments.length - 1];

			return [first.departure.airport, last.arrival.airport];
		} else {
			const segments = flight.segmentGroups[0].segments;
			const first = segments[0];

			return [
				first.departure.airport,
				...flight.segmentGroups
					.map(({ segments }) => segments[segments.length - 1])
					.map(segment => segment.arrival.airport)
			];
		}
	}, [flight.segmentGroups]);

	if (airports.length === 2 && !bookingPreview) {
		return (
			<>
				<div className={css.city}>{airports[0].city?.name ?? airports[0]?.iata ?? ''}</div>
				<div className={cn(css.city, css.main_city)}>{airports[1].city?.name ?? airports[1]?.iata ?? ''}</div>
			</>
		);
	} else {
		return (
			<div className={css.cities_chain}>
				{airports.map((airport, i) => (
					<div className={css.city} key={i}>
						{airport.city?.name ?? airport?.iata ?? ''}
					</div>
				))}
			</div>
		);
	}
};

export default OrderCities;
